module.exports = {"title":"BlackYak alpha","html":"<h2>Home sweet home</h2>\n"};


/*****************
 ** WEBPACK FOOTER
 ** ./pages/home/index.md
 ** module id = 673
 ** module chunks = 0
 **/